/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RelationshipsRelativesIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RelationshipsRelativesIcon({
  children,
  viewPath = "/DesignSystem/Svgs/RelationshipsRelativesIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="RelationshipsRelativesIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-KDCsO': alignSelf,'--mt-2-KDCsO': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-KDCsO': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-KDCsO': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-KDCsO': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-KDCsO': opacity,'--w-10-KDCsO': typeof width === 'number' ? `${width}px` : width,'--h-11-KDCsO': typeof height === 'number' ? `${height}px` : height,'--f-12-KDCsO': fill,'--a-7-KDCsO': isAnimated ? animation : "none",'--sd-8-KDCsO': isAnimated ? strokeDashoffset : 0,'--sd-9-KDCsO': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="RelationshipsRelativesIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M9.107 5.357a1.857 1.857 0 11-3.714 0 1.857 1.857 0 013.714 0zm5.572 0a1.857 1.857 0 11-3.715 0 1.857 1.857 0 013.715 0zM4 10.93v.928c0 .513.416.929.929.929h.464L5.8 16.1a.464.464 0 00.46.399h1.98c.231 0 .427-.17.46-.399l.407-3.315h1.857l.408 3.315a.464.464 0 00.46.399h1.98c.23 0 .427-.17.46-.399l.407-3.315h.464a.929.929 0 00.928-.929v-.928a2.786 2.786 0 00-2.785-2.786h-6.5A2.786 2.786 0 004 10.929z"
 style={{'--f-12-KDCsO': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}